import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from 'assets/landing';
import { navLinks, socialLinks } from './footerLinks';
import Styles from './footer.module.scss';

export const Footer = () => {
	const currentYear = new Date().getFullYear();
	const location = useLocation();

	const isHomePage = true;

	return (
		<div className={`${Styles.container} ${isHomePage && Styles.altContainer}`}>
			<div className="d-flex flex-column gap-4 align-items-center justify-content-between flex-lg-row">
				<div className={Styles.leftColumn}>
					<div className={`${Styles.copyrightRow} ${isHomePage ? Styles.altText : ''}`}>
						<p>&copy; {currentYear} Speakeasy Restaurant All Rights Reserved</p>
						<p>
							Designed and Built by {' '}
							<Link to="https://stellarminore.com" target="_blank" rel="noopener noreferrer">
								Stellar Minore
							</Link>
						</p>
					</div>
					{!isHomePage && <img className={Styles.logo} src={Logo} alt="" />}
					<div className={Styles.informativeLinks}>
						{/* {informativeLinks.map((link) => (
							<Link
								key={link.path}
								to={link.path}
								className={`${isHomePage ? Styles.altText : ''} ${Styles.informativeLink}`}
							>
								{link.label}
							</Link>
						))} */}
					</div>
					{/* {!isHomePage
						&& <div className="d-flex flex-column flex-lg-row w-100 w-lg-auto gap-3 mt-4">
							<input placeholder='Your Email' type='email' className={Styles.emailInput} />
							<Button text='Subscribe' />
						</div>
					} */}
				</div>
				<div className={Styles.rightColumn}>
					<div className={Styles.socialLinks}>
						{socialLinks.map((link, index) => (
							<Link to={link.path} target="_blank" rel="noopener noreferrer">
								<React.Fragment key={index}>
									<link.Icon className={
										`${Styles[link.label]} ${Styles.socialIcons} ${!isHomePage ? Styles.bright : ''}`
									} />
								</React.Fragment>
							</Link>
						))}
					</div>
					{!isHomePage
						&& <div className={Styles.navLinks}>
							{navLinks.map((link) => (
								<Link
									key={link.path}
									to={link.path}
									className={`${Styles.navLink} ${
										location.pathname === link.path ? Styles.selected : ''
									}`}
								>
									{link.label}
								</Link>
							))}
						</div>
					}
				</div>
			</div>
			{/* <div className={`${Styles.copyrightRow} ${isHomePage ? Styles.altText : ''}`}>
				<p>&copy; 2025 Speakeasy Restaurant All Rights Reserved</p>
				<p>
					Designed and Built by {' '}
					<Link to="https://stellarminore.com" target="_blank" rel="noopener noreferrer">
						Stellar Minore
					</Link>
				</p>
			</div> */}
		</div>
	);
};
